import React, { Component } from "react";

class AppleBM extends Component {
    render() {
        return (
            <div className="bg-apple-bm" >
                <div className='col-lg-4 box-Apple'>
                    <h3>Implemente aparelhos Apple de forma fácil e integrada
                    <a style={{fontSize:16, display:'flex', color: '#FFFF01'}}
                        onClick href="/AppleABM">
                       
                            Saiba mais
                    </a>


                    </h3>
                   
                </div>
            </div>
        )

    }
}
export default AppleBM;
